import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import animations from "./animations";
import FeatureItem from "../../elements/FeatureItem";
import Button from "../../elements/Button";

class Features extends Component {

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props && this.props.dataReceived) {
			animations.initialise(this);
		}
	}

	getItem(key) {
		if (this.props.items[key]) {
			return (
				<FeatureItem title={this.props.items[key]} />
			);
		}
	}

	render() {
		return (
			<div className="voip-features">
				<div className="row">
					<div className="col-xs-12 col-md-10 col-md-offset-1">
						<div className="inner">
							<BrowserView>
								<div>
									{this.getItem(0)}
									{this.getItem(1)}
								</div>
								<div>
									<div className="flex-row top">
                                        <div>{this.getItem(2)}</div>
                                        <div>{this.getItem(3)}</div>

									</div>
									<div className="title">
										<img src="/images/banter.svg" alt="Banter by Exetel" className="banter" />
										<img src="/images/by-exetel.svg" alt="Banter by Exetel" className="by-exetel" />
									</div>
									<div className="flex-row bottom">
                                        <div>{this.getItem(6)}</div>
                                        <div>{this.getItem(7)}</div>
									</div>
								</div>
								<div>
                                    {this.getItem(4)}
									{this.getItem(5)}
								</div>
							</BrowserView>
							<MobileView>
								<img src="/images/banter-by-exetel.svg" alt="Banter by Exetel" className="banter" />
								<ul>
								{this.props.items.map((value, key) => {
									return (
										<li key={key} dangerouslySetInnerHTML={{__html: `&bullet; ${value}`}} />
									);
								})}
								</ul>
							</MobileView>
						</div>

						<div className="price">
							<span>{this.props.price}</span>
							{this.props.leadCopy.map((value, key) => {
								return (
									<p key={key}>{value}</p>
								);
							})}
							<Button action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null} image="/images/btn-enquire-now-darkgreen.svg" />
						</div>
					</div>
				</div>
			</div>
		);
	}

}

export default Features;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Features/Features.js